import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textField", "player", "tempUrl"];

  connect() {
    const lexiconData = this.data.get("ipa-lexicon");
    this.ipaLexicon = lexiconData ? JSON.parse(lexiconData) : {};
  }

  applyIpaLexicon(text) {
    let result = text;
    for (const [word, phoneme] of Object.entries(this.ipaLexicon)) {
      const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(`\\b${escaped}\\b`, "gi");
      result = result.replace(
        regex,
        (match) => `<phoneme alphabet="ipa" ph="${phoneme}">${match}</phoneme>`
      );
    }
    return result;
  }

  async generateTempUrlBeforeSubmit(event) {
    const currentText = this.textFieldTarget.value;

    // If we've already generated the preview for this text, allow submission
    if (this.data.has("previewText") && this.data.get("previewText") == currentText) {
      // Clear the flag so it regenerates on next edit
      this.data.delete("previewText");
      return;
    }

    // Stop the Turbo submission so we can generate the preview first
    event.preventDefault();
    event.stopPropagation();

    await this.generatePreview();

    const form = this.textFieldTarget.closest("form");
    // Resume the Turbo fetch request
    form.requestSubmit();
  }

  async previewSpokenText(event) {
    event.preventDefault();
    event.stopPropagation();
    const link = event.target;
    if (link.classList.contains("disabled")) {
      return;
    }
    link.classList.add("disabled");
    await this.generatePreview();
    link.classList.remove("disabled");
    this.playPreview();
  }

  async generatePreview() {
    const rawText = this.textFieldTarget.value;
    this.data.set("previewText", rawText);
    const tempUrl = this.tempUrlTarget;
    if (rawText.length == 0) {
      return;
    }
    const text = this.applyIpaLexicon(rawText);
    await fetch(this.data.get("polly-url"), {
      body: JSON.stringify({ text: text }),
      method: "POST",
      mode: "cors",
      dataType: "json",
    })
      .then((response) => response.json())
      .then((data) => {
        tempUrl.value = data.url;
      });
  }

  playPreview() {
    // alert(url)
    const audioPlayer = document.createElement("audio");
    this.playerTarget.innerHTML = "";
    audioPlayer.src = this.tempUrlTarget.value;
    audioPlayer.setAttribute("controls", "");
    this.playerTarget.appendChild(audioPlayer);
    audioPlayer.play();
  }
}
